var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _vm.abrirModal
        ? _c("app-modal-selecionar-tipo-processo", {
            attrs: { tipos: _vm.tipos, usuario: _vm.usuarioSelecionado },
            on: { closeModal: _vm.fecharModal }
          })
        : _vm._e(),
      _c(
        "el-card",
        [
          _c("app-divider", {
            staticClass: "margin-top",
            attrs: {
              label: "Gerenciamento de processos / usuários",
              showBorder: false
            }
          }),
          _c("app-search", {
            staticClass: "extra-margin-top",
            on: { input: _vm.buscaSimples },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _c("app-divider", {
            staticClass: "margin-top",
            attrs: { label: "Usuários" }
          }),
          _c(
            "el-table",
            { staticClass: "texto", attrs: { data: _vm.perfisUsuarios } },
            [
              _c("el-table-column", {
                attrs: { label: "Nome", formatter: _vm.formatNome }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Processos Vinculados",
                  formatter: _vm.formatProcessos
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "small" } },
                              [
                                _vm._v("Ações"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c("el-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex",
                                      on: {
                                        click: function($event) {
                                          return _vm.abreModal(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("trending_up")]
                                      ),
                                      _vm._v("  Gerenciar Permissões")
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticClass: "btn-voltar margin-top",
              attrs: { type: "default" },
              on: { click: _vm.voltar }
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _c("b", [_vm._v("  Voltar")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5640e564", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5640e564","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/GestaoProcessoUsuario.vue
// module id = null
// module chunks = 